import { isCollapsed, PlateEditor } from '@udecode/plate';
import { useCallback } from 'react';
import { Range } from 'slate';

import { useComboBoxStore } from '../store';
import { getTextFromTrigger } from '../utils';

/**
 * If the cursor is after the trigger and at the end of the word:
 * Set target range, set search, reset tag index.
 */
export const useComboboxOnChange = ({
  key,
  trigger,
}: {
  key: string;
  trigger: string;
}): ((editor: PlateEditor) =>
  | {
      search: string;
    }
  | undefined) => {
  const setTargetRange = useComboBoxStore((state) => state.setTargetRange);
  const setSearch = useComboBoxStore((state) => state.setSearch);
  const setKey = useComboBoxStore((state) => state.setKey);

  return useCallback(
    (editor) => {
      const selection = editor?.selection;
      if (selection && isCollapsed(selection)) {
        const cursor = Range.start(selection);

        const isCursorAfterTrigger = getTextFromTrigger(editor, {
          at: cursor,
          trigger,
        });
        if (isCursorAfterTrigger) {
          const { range, textAfterTrigger } = isCursorAfterTrigger;

          setKey(key);
          setTargetRange(range);
          setSearch(textAfterTrigger);

          return {
            search: textAfterTrigger,
          };
        }
      }
    },
    [trigger, setKey, key, setTargetRange, setSearch]
  );
};
